export enum ECallTransferType {
	COLD = 'Cold Transfer (Without Summary)',
	HOT = 'Hot Transfer (With Summary)',
}

export enum EHandoffMessageType {
	PROMPT = 'Prompt',
	STATIC = 'Static Word',
}
